import { useAPIMutation } from "@/api/api";
import { IFActivityDetail } from "@/api/apiRsp/IFActivityList";
import { IFEmpty } from "@/api/apiRsp/IFEmpty";
import { useEffect, useRef, useState } from "react";
import { useGlobalState } from "@/store/commonStore";
import { useUserInfo } from "@/store/userInfo";

type TriggerOptions = {
  // Whether this fetch is triggered by "just became logged-in" event.
  loginEnter?: boolean;
};

export const useActivityPopupList = () => {
  // showPosition参数活动图片显示位置 1 PC 2手机弹窗 3手机活动页
  const { data, error, isMutating, trigger: apiTrigger } = useAPIMutation<
    IFActivityDetail[],
    any
  >({ path: "api/activity/list", type: "post" });
  const [popList, setPopList] = useState<IFActivityDetail[]>([]);

  const { data: userInfo } = useUserInfo();
  const { isLogin } = useGlobalState();
  const loginEnterRef = useRef(false);

  const trigger = async (params: any, options?: TriggerOptions) => {
    loginEnterRef.current = !!options?.loginEnter;
    return apiTrigger(params);
  };

  //有且当isPop为1才有效 true过滤 false不过滤
  const popCheck = (e) => {
    return e && e.isPop !== 1;
  };
  /**
   * 未登录弹窗 才是未登录就会弹
   * 其他都是默认 登录后
   * 1登录 2返回首页 3是否可以关闭 4未登录
   */
  const popTypeCheck = (e) => {
    if (e.popType === "") {
      return true;
    }
    if (!isLogin) {
      return !e.popType?.includes("4");
    } else {
      //返回首页
      if (
        e.popType?.includes("2") &&
        window.location.pathname.includes("home")
      ) {
        return false;
      }
      return !(e.popType?.includes("1") && loginEnterRef.current);
    }
  };
  //本地弹窗有效判定
  const localCheck = (e) => {
    const key = `today-nopop-${isLogin ? userInfo?.userId : ""}-${e?.id}`;
    const item = localStorage.getItem(key);
    if (item) {
      const day = JSON.parse(item);
      if (day === new Date().toLocaleDateString()) {
        return true;
      }
    }
    return false;
  };
  //是否过滤首充
  const firstRechargeCheck = (e) => {
    return userInfo?.isFirstRecharge && e.activityType === 7;
  };
  //是否过滤签到
  // const checkInCheck = (e) => {
  //   return isCheckIn && e.activityType === 6;
  // };
  //过滤已绑定手机号的活动
  const bindPhoneCheck = (e) => {
    return userInfo?.mobile?.length && e.jumpTo === "4";
  };

  const rules = [
    popCheck,
    popTypeCheck,
    localCheck,
    firstRechargeCheck,
    bindPhoneCheck,
  ];

  useEffect(() => {
    if (data) {
      // 纯活动列表：过滤 + 排序，不再注入首充/邀请（它们已独立走编排器）
      const filtered =
        data
          ?.map((e) => {
            for (const iterator of rules) {
              if (e && iterator(e)) {
                return undefined;
              }
            }
            return e;
          })
          .filter(Boolean)
          .sort((a, b) => b.updateTime - a.updateTime) || [];

      setPopList(filtered);
    }
  }, [data, userInfo]);

  return {
    popList,
    data,
    error,
    isMutating,
    trigger,
  };
};

/**
 * 7日连续签到
 */
export function useCheckIn7Days() {
  return useAPIMutation<IFEmpty, IFEmpty>({
    path: "api/activity/checkIn7Days",
    type: "get",
  });
}

/**
 * 签到
 * @returns
 */
export function useCheckIn() {
  return useAPIMutation<IFEmpty, IFEmpty>({
    path: "api/activity/checkIn",
    type: "post",
  });
}
